import "./ModalContent1.scss";

function ModalContent1() {
  return (
    <div className="modal-content-1">
      <h1>ModalContent1</h1>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
      <p>This is a modal with some content</p>
    </div>
  );
}

export default ModalContent1;
